// import 'date-fns';
import React, { useEffect, useState } from "react";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import { primary_color } from "../../style_constants";
import AddCircleIcon from "@material-ui/icons/AddCircle";
export const dateFinder = (str) => {
  let dateRegex = /\d\d\d\d-\d\d-\d\d/i;
  const dateRegex2 = /\d\d\/\d\d\/\d\d\d\d/i;
  if (!(str instanceof Date)) {
    if (str && str !== "Invalid date") {
      if (str?.toString().toLowerCase().includes("utc")) {
        return new Date(str.match(dateRegex)[0]).toLocaleString("en-GB", {
          dateStyle: "short",
        });
      } else if (str.length <= 10 && str.match(dateRegex2)) {
        return new Date(
          str.replaceAll("/", "-").split("-").reverse().join("-")
        ).toLocaleString("en-GB", { dateStyle: "short" });
      } else {
        return new Date(str).toLocaleString("en-GB", { dateStyle: "short" });
      }
    } else {
      return "";
    }
  } else {
    return str.toLocaleString("en-GB", { dateStyle: "short" });
  }
};
export const DatePicker = (props) => {
  const {
    label,
    id,
    index,
    value,
    handleChange,
    helperText,
    disabled,
    selectValue,
    placeholder,
    autoFocus,
    futureDateHide,
    plusIcon,
    isDynamicField,
    getAllValue,
    customStyle,
  } = props.componentObject;

  const [changed, setChanged] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {
      "& > *": {
        margin: theme.spacing(1),
        display: "flex",
      },
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
  }));

  // const theme = createMuiTheme({
  //   overrides: {
  //     MuiPickersToolbar: {
  //       toolbar: {
  //         backgroundColor: primary_color,
  //       },
  //     },
  //     MuiPickersDay: {
  //       daySelected: {
  //         backgroundColor: primary_color,
  //       },
  //     },
  //     MuiButton: {
  //       textPrimary: {
  //         color: primary_color,
  //       },
  //     },
  //     MuiFormControl: {
  //       marginNormal: {
  //         marginTop: "0px",
  //         marginBottom: "0px",
  //         // marginLeft: "1px"
  //       },
  //     },
  //     MuiOutlinedInput: {
  //       input: {
  //         color: !disabled && "black",
  //         "&::placeholder": {
  //           color: "#808080 !important",
  //           opacity: 1,
  //         },
  //       },
  //     },
  //   },
  // });

  const classes = useStyles();
  const [fields, setFields] = useState([""]);

  function handleAdd() {
    const values = [...fields];
    values.push("");
    setFields(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
  }

  useEffect(() => {
    value?.length && plusIcon && setFields(value);
  }, [value?.length]);

  return (
    <React.Fragment>
      {plusIcon === "yes" ? (
        <React.Fragment>
          <Grid container className={classes.gridRoot} style={customStyle}>
            {fields?.map((field, idx) => {
              return (
                <>
                  <Grid item xs={11} md={11}>
                    <div
                      key={`${field}-${idx}`}
                      style={{ marginBottom: "5px" }}
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          fullWidth
                          clearable
                          placeholder={placeholder || "MM/DD/YYYY"}
                          inputVariant="outlined"
                          size="small"
                          margin="normal"
                          format="dd/MM/yyyy"
                          value={field}
                          disabled={disabled}
                          error={helperText ? true : false}
                          helperText={helperText}
                          maxDate={futureDateHide ? new Date() : undefined}
                          disablePast={false}
                          onChange={(val) => {
                            if (getAllValue) {
                              const newFields = [...fields];
                              newFields[idx] = val;
                              setFields(newFields);
                              handleChange(
                                newFields,
                                index,
                                props.componentObject.selectValue?.index,
                                isDynamicField
                              );
                            } else {
                              handleChange(
                                val,
                                index,
                                props.componentObject.selectValue?.index,
                                isDynamicField
                              );
                            }
                            setChanged(true);
                          }}
                          // onMouseEnter={() => setDisable(false)}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          InputProps={{
                            readOnly: true,
                            placeholder: "Please enter a date",
                            defaultValue: "",
                            value:
                              value && value !== "Invalid date"
                                ? new Date(value).toLocaleString("en-GB", {
                                    dateStyle: "short",
                                  })
                                : "",
                          }}
                        />
                        {/* </Grid> */}
                      </MuiPickersUtilsProvider>
                      {/* </ThemeProvider> */}
                    </div>
                  </Grid>
                  <Grid item xs={12} md={1}>
                    {idx ? (
                      <AddCircleIcon
                        type="submit"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemove(idx);
                        }}
                        fontSize="large"
                        color="error"
                        style={{
                          cursor: "pointer",
                          transform: "rotate(45deg)",
                          float: "right",
                        }}
                      />
                    ) : (
                      <AddCircleIcon
                        type="submit"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAdd();
                        }}
                        fontSize="large"
                        color="primary"
                        style={{ cursor: "pointer", float: "right" }}
                      />
                    )}
                  </Grid>
                </>
              );
            })}
          </Grid>
        </React.Fragment>
      ) : (
        // <ThemeProvider theme={theme}>
        <Grid container className={classes.gridRoot} style={customStyle}>
          <Grid item xs={12} md={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {/* <MuiPickersUtilsProvider > */}
              {/* <Grid container> */}
              <KeyboardDatePicker
                fullWidth
                autoFocus={autoFocus ? true : false}
                placeholder={placeholder ? placeholder : "Please enter a date"}
                inputVariant="outlined"
                size="small"
                margin="normal"
                format="dd/MM/yyyy"
                value={value}
                clearable
                error={helperText ? true : false}
                helperText={helperText}
                maxDate={futureDateHide ? new Date() : undefined}
                disablePast={false}
                disabled={disabled}
                // InputProps={{ error: helperText ? true : false, helperText: 'helperText' }}
                onChange={(val) => {
                  handleChange(
                    val,
                    index,
                    props.componentObject.selectValue?.index,
                    isDynamicField
                  );
                  setChanged(true);
                }}
                // onMouseEnter={() => setDisable(false)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                InputProps={{
                  readOnly: true,
                  placeholder: "Please enter a date",
                  value: dateFinder(value),
                }}
              />
              {/* </Grid> */}
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        // </ThemeProvider>
      )}
    </React.Fragment>
  );
};

export default function DateComponent(props) {
  const { label } = props.componentObject;
  const [anchorEl, setAnchorEl] = useState("");

  const handleClick = (event) => {
    setAnchorEl("display");
  };

  return (
    <Grid container>
      {label && (
        <Grid item xs={12} md={4}>
          {label}
        </Grid>
      )}
      <Grid item xs={12} md={label ? 7 : 12}>
        <DatePicker componentObject={props.componentObject} />
      </Grid>
    </Grid>
  );
}
